import React from 'react';
import { useGlobalContext } from 'globalContext';
import { ButtonShare as MspButtonShare } from 'msp-components';

const ButtonShare = () => {
  const { showShareSheet, toggleShareSheet } = useGlobalContext();
  return <MspButtonShare active={showShareSheet} onClick={toggleShareSheet} />;
};

export default ButtonShare;
